<script setup lang="tsx">
// TODO: New global modal component exists - ModalComponent. Keeping this for now, to avoid refactoring code that still uses it.
import { ref, onMounted, watch, onBeforeUnmount } from 'vue'
import { Modal } from 'bootstrap'

const props = defineProps<{
	class?: string
	hideFooter?: boolean
	type?: string
}>()
const model = defineModel<boolean>({ required: true })
const emit = defineEmits<{
	confirm: []
	cancel: []
	closed: [confirmed: boolean]
}>()
const modalRef = ref<HTMLElement | null>(null)

let modalInstance: Modal | null = null
let modalShown = false
let confirmed = false

onMounted(() => {
	const modalElement = modalRef.value
	if (modalElement) {
		document.body.insertAdjacentElement('afterbegin', modalElement)

		modalInstance = new Modal(modalElement, {
			backdrop: 'static',
		})

		modalElement.addEventListener('shown.bs.modal', () => {
			modalShown = true
			confirmed = false
			if (!model.value) model.value = true
		})

		modalElement.addEventListener('hidden.bs.modal', () => {
			modalShown = false
			if (model.value) model.value = false
			emit('closed', confirmed)
		})

		if (model.value) {
			modalInstance.show()
		}
	}
})

onBeforeUnmount(() => {
	if (modalInstance && modalShown) {
		modalRef.value?.addEventListener('hidden.bs.modal', () => {
			modalInstance?.dispose()
		})
		modalInstance.hide()
	} else if (modalInstance) {
		modalInstance.dispose()
	}
})

watch(model, (newValue) => {
	if (modalInstance) {
		if (newValue && !modalShown) {
			modalInstance.show()
		} else if (!newValue && modalShown) {
			modalInstance.hide()
		}
	}
})

function confirm() {
	confirmed = true
	emit('confirm')
}

function cancel() {
	confirmed = false
	emit('cancel')
}
</script>

<template>
	<div ref="modalRef" class="modal fade" :class="props.class" :data-test="'modal-' + props.type" tabindex="-1">
		<div class="modal-dialog" :class="props.class">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title w-100">
						<slot name="header">Default Title</slot>
					</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancel"></button>
				</div>
				<div class="modal-body">
					<slot name="body">
						<p>Default Body Content</p>
					</slot>
				</div>
				<template v-if="!hideFooter">
					<div class="modal-footer">
						<slot name="footer">
							<button :data-test="'cancel-' + type" type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="cancel">
								{{ $t('misc.cancel') }}
							</button>
							<button :data-test="'confirm-' + type" type="button" class="btn btn-primary" @click="confirm">
								{{ $t('misc.confirm') }}
							</button>
						</slot>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>
